"use client";
import React, { useState } from "react";
import Link from "next/link";
import { FaEnvelope, FaKey, FaLock } from "react-icons/fa";
import EmailForm from "../../components/auth/Email";
import VerificationCode from "../../components/auth/VerificationCode";
import ChangePassword from "../../components/auth/ChangePassword";

const STEPS = [
  { icon: <FaEnvelope />, title: "E-Mail eingeben", text: "Wir schicken Ihnen einen Code." },
  { icon: <FaKey />, title: "Code bestätigen", text: "Den 6-stelligen Code aus der E-Mail." },
  { icon: <FaLock />, title: "Neues Passwort", text: "Und schon können Sie sich anmelden." },
];

const PasswordResetPage = () => {
  const [step, setStep] = useState(1); // 1: E-Mail, 2: Code, 3: Passwort
  const [email, setEmail] = useState("");

  return (
    <section className="bg-ao-bg text-ao-fg">
      <div className="mx-auto grid min-h-[calc(100vh-5rem)] max-w-[1440px] lg:grid-cols-2">

        {/* Links (nur Laptop): die 3 Schritte */}
        <div className="hidden flex-col justify-center gap-10 px-20 py-16 lg:flex">
          <div className="flex flex-col gap-5">
            <span className="text-[13px] font-semibold tracking-[0.18em] text-ao-accent-fg">PASSWORT VERGESSEN</span>
            <h1 className="font-display text-7xl font-extrabold uppercase leading-[0.92]">
              Kein
              <br />
              <span className="text-ao-accent-fg">Problem.</span>
            </h1>
            <p className="max-w-md text-lg leading-relaxed text-ao-muted">
              In drei kurzen Schritten setzen Sie ein neues Passwort.
            </p>
          </div>
          <ol className="flex flex-col gap-4">
            {STEPS.map((s, i) => {
              const n = i + 1;
              const active = n === step;
              const done = n < step;
              return (
                <li key={s.title} className={`flex items-center gap-4 ${active || done ? "" : "opacity-50"}`}>
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${
                      active ? "bg-ao-accent text-ao-on-accent" : "bg-ao-surface-2 text-ao-accent-fg"
                    }`}
                  >
                    {s.icon}
                  </span>
                  <span className="flex flex-col">
                    <span className="text-[17px] font-semibold">{s.title}</span>
                    <span className="text-sm text-ao-muted">{s.text}</span>
                  </span>
                </li>
              );
            })}
          </ol>
        </div>

        {/* Rechts: aktueller Schritt */}
        <div className="flex items-center justify-center px-5 py-12 lg:px-20">
          <div className="flex w-full max-w-md flex-col gap-8">
            <div className="flex flex-col gap-3">
              <h2 className="font-display text-5xl font-extrabold uppercase leading-none">
                {step === 3 ? "Neues Passwort" : "Passwort vergessen"}
              </h2>
              <p className="text-[15px] text-ao-muted">
                Schritt {step} von 3 · {STEPS[step - 1].title}
              </p>
              <div className="flex gap-2" aria-hidden="true">
                {[1, 2, 3].map((n) => (
                  <span key={n} className={`h-1 flex-1 rounded-full ${n <= step ? "bg-ao-accent" : "bg-ao-line"}`} />
                ))}
              </div>
            </div>

            {step === 1 && <EmailForm onNextStep={() => setStep(2)} setEmail={setEmail} />}
            {step === 2 && <VerificationCode email={email} onNextStep={() => setStep(3)} onBack={() => setStep(1)} />}
            {step === 3 && <ChangePassword email={email} />}

            <Link href="/login" className="text-center text-sm font-semibold text-ao-muted hover:text-ao-fg">
              ← Zurück zum Login
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PasswordResetPage;
